module.exports = __webpack_public_path__ + "static/media/financepic6@2x.48c32046.png";